import React, { useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";

// Approve or reject a pending payment. Only approved payments change the
// ledger balance; rejected ones are kept in the history as "cancelled".
export default function PaymentApprovalButton({ payment, onApproved, t }) {
    const [busy, setBusy] = useState(null);

    const updatePayment = async (action) => {
        const approving = action === "approve";
        const confirmation = await Swal.fire({
            icon: approving ? "question" : "warning",
            title: approving ? t("Approve this payment?") : t("Reject this payment?"),
            text: approving
                ? t("It will be counted in the ledger balance.")
                : t("It will be marked as cancelled and not counted."),
            showCancelButton: true,
            confirmButtonText: approving ? t("Approve") : t("Reject"),
            confirmButtonColor: approving ? "#198754" : "#dc3545",
            cancelButtonText: t("Go back"),
        });
        if (!confirmation.isConfirmed) return;

        setBusy(action);
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_API_URL}/admin/payments/${payment.id}/${approving ? "approve" : "cancel"}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                        Accept: "application/json",
                    },
                }
            );
            if (!response.data?.success) {
                throw new Error(response.data?.message || "Failed to update payment.");
            }

            await Swal.fire({
                icon: "success",
                title: approving ? t("Payment approved") : t("Payment rejected"),
                text: response.data?.message || t("Payment status updated successfully."),
                timer: 1800,
                showConfirmButton: false,
            });
            await onApproved();
        } catch (err) {
            console.error("Error updating payment:", err);
            Swal.fire({
                icon: "error",
                title: t("Payment update failed"),
                text: err.response?.data?.message || err.message || t("Please try again."),
            });
        } finally {
            setBusy(null);
        }
    };

    if ((payment.status || "").toLowerCase() !== "pending") return "-";

    return (
        <div className="d-flex gap-1 justify-content-end flex-wrap">
            <Button variant="success" size="sm" disabled={!!busy} onClick={() => updatePayment("approve")}>
                {busy === "approve" ? <Spinner size="sm" animation="border" /> : t("Approve")}
            </Button>
            <Button variant="danger" size="sm" disabled={!!busy} onClick={() => updatePayment("reject")}>
                {busy === "reject" ? <Spinner size="sm" animation="border" /> : t("Reject")}
            </Button>
        </div>
    );
}
